import mitt from 'mitt';
import Util from '@/helper/Utility.js';

export function PdpaModalController() {
    this.title = '';
    this.type = '';
    this.version = '';
    this.btnOk = '';
    this.btnCancel = '';
    this.busModal = mitt();

    this.alertModal = null;

    this.callbackAccept = null;
    this.callbackClose = null;

    //#region setter
    this.clearModal = function () {
        this.title = '';
        this.btnOk = '';
        this.btnCancel = '';
        this.callbackAccept = null;
        this.callbackClose = null;
        return this;
    };
    this.setTitle = function (title) {
        this.title = title;
        return this;
    };
    this.setType = function (type) {
        this.type = type;
        return this;
    };
    this.setVersion = function (version) {
        this.version = version;
        return this;
    };
    this.setBtnOk = function (btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setBtnCancel = function (btnCancel) {
        this.btnCancel = btnCancel;
        return this;
    };
    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function (opts = {}) {
        const config = {
            title: this.title,
            btnOk: this.btnOk,
            btnCancel: this.btnCancel,
            type: this.type,
            ...opts
        };
        this.busModal.emit('show', config);
    };
    this.hide = function () {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickAccept = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackAccept = callback;
        }
        return this
    }
    this.sendCallbackAccept = function (data) {
        if (Util.isFunction(this.callbackAccept)) {
            this.callbackAccept(data);
        }
    }
    this.onClickClose = function (callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }
        return this
    }
    this.sendCallbackClose = function (data) {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose(data);
        }
    }
    //#endregion event
}